import { render } from "./PayMortgageButton.vue?vue&type=template&id=2b941e86"
import script from "./PayMortgageButton.vue?vue&type=script&lang=js"
export * from "./PayMortgageButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__